export const API_VERSION = 'v1';
export const API_PREFIX = `/api/${API_VERSION}`;

// CHG-131: 프로필 16색 팔레트
export * from './profileColors.js';

// CHG-137: JPD 스타일 아이디어 — 5단계 ↔ float 매핑
export * from './ideaScoring.js';

// CHG-041: 상태 카테고리 라벨 (동적 워크플로우 기반)
export const STATUS_CATEGORY_LABELS: Record<string, string> = {
  TODO: '할 일',
  IN_PROGRESS: '진행 중',
  DONE: '완료',
};

// 명세서 3.5.4: 우선순위
export const PRIORITY_LABELS: Record<string, string> = {
  BLOCKER: '블로커',
  CRITICAL: '긴급',
  HIGH: '높음',
  MEDIUM: '보통',
  LOW: '낮음',
};

// 명세서 3.5.4: 이슈 유형
export const ISSUE_TYPE_LABELS: Record<string, string> = {
  BUG: '버그',
  TASK: '작업',
  STORY: '스토리',
  EPIC: '에픽',
  SUB_TASK: '하위 작업',
};

// 명세서 6.2: 요구사항 상태
export const REQUIREMENT_STATUS_LABELS: Record<string, string> = {
  DRAFT: '초안',
  REVIEW: '검토 중',
  APPROVED: '승인됨',
  DEPRECATED: '폐기',
};

// 명세서 3.2.2: 요구사항 카테고리
export const REQUIREMENT_CATEGORY_LABELS: Record<string, string> = {
  FUNCTIONAL: '기능',
  NON_FUNCTIONAL: '비기능',
  CONSTRAINT: '제약사항',
};

// 명세서 3.3.2: 기능 명세 상태
export const SPECIFICATION_STATUS_LABELS: Record<string, string> = {
  DRAFT: '초안',
  IN_REVIEW: '검토 중',
  APPROVED: '승인됨',
  IMPLEMENTED: '구현됨',
};

// 명세서 3.4.3: 테스트케이스 상태
export const TEST_CASE_STATUS_LABELS: Record<string, string> = {
  NOT_RUN: '미실행',
  PASS: '통과',
  FAIL: '실패',
  BLOCKED: '차단됨',
  SKIP: '건너뜀',
};

// 명세서 3.4.3: 테스트 유형
export const TEST_TYPE_LABELS: Record<string, string> = {
  POSITIVE: '정상',
  NEGATIVE: '비정상',
  BOUNDARY: '경계값',
  ALTERNATIVE: '대안',
};

// 명세서 3.5.4: 이슈 해결 유형
export const ISSUE_RESOLUTION_LABELS: Record<string, string> = {
  FIXED: '수정됨',
  WONT_FIX: '수정 안 함',
  DUPLICATE: '중복',
  CANNOT_REPRODUCE: '재현 불가',
};

export const SOCKET_EVENTS = {
  // Issue events
  ISSUE_CREATED: 'issue:created',
  ISSUE_UPDATED: 'issue:updated',
  ISSUE_DELETED: 'issue:deleted',
  ISSUE_STATUS_CHANGED: 'issue:statusChanged',
  ISSUE_COMMENTED: 'issue:commented',
  // TestCase events
  TESTCASE_EXECUTED: 'testcase:executed',
  TESTCASE_FAILED: 'testcase:failed',
  TESTCASE_REVIEW_COMPLETED: 'testcase:reviewCompleted',
  TESTCASE_BATCH_REVIEW_COMPLETED: 'testcase:batchReviewCompleted',
  // TestRun events (CHG-012)
  TESTRUN_CREATED: 'testrun:created',
  TESTRUN_RESULT_UPDATED: 'testrun:resultUpdated',
  TESTRUN_STATUS_CHANGED: 'testrun:statusChanged',
  // Requirement events
  REQUIREMENT_UPDATED: 'requirement:updated',
  // Notification events
  NOTIFICATION_NEW: 'notification:new',
  // Dashboard events
  DASHBOARD_REFRESH: 'dashboard:refresh',
  // Chat events (CHG-031)
  CHAT_JOIN: 'chat:join',
  CHAT_LEAVE: 'chat:leave',
  CHAT_SEND: 'chat:send',
  CHAT_NEW_MESSAGE: 'chat:newMessage',
  CHAT_UNREAD_UPDATE: 'chat:unreadUpdate',
  CHAT_ERROR: 'chat:error',
  // Channel events (CHG-075)
  CHANNEL_JOIN: 'channel:join',
  CHANNEL_LEAVE: 'channel:leave',
  CHANNEL_SEND: 'channel:send',
  CHANNEL_NEW_MESSAGE: 'channel:newMessage',
  CHANNEL_UNREAD_UPDATE: 'channel:unreadUpdate',
  CHANNEL_ERROR: 'channel:error',
  CHANNEL_INVITED: 'channel:invited',
  CHANNEL_REMOVED: 'channel:removed',
  CHANNEL_KICKED: 'channel:kicked',
  CHANNEL_MEMBER_KICKED: 'channel:memberKicked',
  CHANNEL_MESSAGE_EDITED: 'channel:messageEdited',
  CHANNEL_MESSAGE_DELETED: 'channel:messageDeleted',
  CHANNEL_REACTION_UPDATED: 'channel:reactionUpdated',
  CHANNEL_TYPING_START: 'channel:typing:start',
  CHANNEL_TYPING_STOP: 'channel:typing:stop',
  CHANNEL_TYPING: 'channel:typing',
  CHANNEL_THREAD_MESSAGE: 'channel:threadMessage',
  CHANNEL_MESSAGE_PINNED: 'channel:messagePinned',
  CHANNEL_MESSAGE_UNPINNED: 'channel:messageUnpinned',
  CHANNEL_MENTIONED: 'channel:mentioned',
  CHANNEL_ARCHIVED: 'channel:archived',
  CHANNEL_UNARCHIVED: 'channel:unarchived',
  // CHG-123: 메시지 → 작업/할 일 변환 시 linkedResources 갱신
  CHAT_MESSAGE_LINKED_RESOURCE_UPDATED: 'chat:message:linked-resource-updated',
  // Connection events
  JOIN_PROJECT: 'project:join',
  LEAVE_PROJECT: 'project:leave',
  JOIN_USER: 'user:join',
  // Design events (CHG-049)
  DESIGN_ITEM_CREATED: 'designItem:created',
  DESIGN_ITEM_UPDATED: 'designItem:updated',
  DESIGN_ITEM_DELETED: 'designItem:deleted',
  DESIGN_ITEM_STATUS_CHANGED: 'designItem:statusChanged',
  DESIGN_REVIEW_REQUESTED: 'designReview:requested',
  DESIGN_REVIEW_SUBMITTED: 'designReview:submitted',
  FIGMA_FILE_UPDATED: 'figma:fileUpdated',
  FIGMA_VERSION_CREATED: 'figma:versionCreated',
  // CHG-139: 사용자 프로필 변경 broadcast (org:{orgId} room으로 전송)
  USER_PROFILE_UPDATED: 'user:profileUpdated',
} as const;

// CHG-139 REQ-PF-001: USER_PROFILE_UPDATED 이벤트 payload
// payload 키는 { userId } 1개로 고정 — 수신측은 invalidate 키 트리거 용도로만 사용
export interface UserProfileUpdatedPayload {
  userId: string;
}

// TestEnvProfile 제약
export const MAX_TEST_ENV_PROFILES_PER_USER = 10;

// REQ-V17-004: 프로젝트 유형별 허용 기능 목록
// CHG-130 REQ-DHR-025: 모든 프로젝트 유형에 'documents' 추가 (fixed)
export const PROJECT_FEATURES: Record<string, string[]> = {
  SCRUM: ['requirements', 'specs', 'testcases', 'test-results', 'issues', 'settings', 'dashboard', 'board', 'schedule', 'chat', 'sprint', 'documents'],
  KANBAN: ['requirements', 'specs', 'testcases', 'test-results', 'issues', 'settings', 'dashboard', 'board', 'schedule', 'chat', 'sprint', 'documents'],
  CS: ['issues', 'settings', 'dashboard', 'chat', 'sprint', 'documents'],
  TEAM: ['dashboard', 'sprint', 'issues', 'settings', 'chat', 'documents'],
};
